import * as React from "react";
import cafe from "../images/café.png";
import soja from "../images/soja.png";
import trigo from "../images/trigo.png";
import milho from "../images/milho.png";
import cana from "../images/cana-de-açúcar.png";
import defaultImage from "../images/default.png";
import { useMemo } from "react";

interface CultureImagesProps {
  cultureName: string;
}

const styles = {
  image: {
    borderRadius: 10,
    width: "100%",
  },
};

const CultureImages: React.FC<CultureImagesProps> = ({ cultureName }) => {
  const imagePath = useMemo(() => {
    switch (cultureName) {
      case "Café":
        return cafe;
      case "Soja":
        return soja;
      case "Trigo":
        return trigo;
      case "Milho":
        return milho;
      case "Cana-de-açucar":
        return cana;
      default:
        return defaultImage;
    }
  }, [cultureName]);

  return (
    <img
      src={imagePath}
      alt={`Lavoura de ${cultureName}`}
      style={styles.image}
    />
  );
};

export default CultureImages;
